import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from '@core/services/auth/auth.service';
import { AuthGuardService } from '@core/services/guards/auth-guard.service';
import { SftpInfoService } from '@core/services/sftp/sftp-info.service';
import { UserService } from '@core/services/user/user.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { SharedModule } from '@shared/shared.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxPrintModule } from 'ngx-print';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { AccountViewComponent } from './account-view/account-view.component';
import { QueueHistoryDialogComponent } from './account-view/queue-history-dialog/queue-history-dialog.component';

import { AdminReportComponent } from './admin-report/admin-report.component';
//import { AnnouncementComponent } from './announcement/announcement.component';
//import { EditAnnouncementComponent } from './announcement/components/edit-announcement/edit-announcement.component';
//import { PreviewAnnouncementComponent } from './announcement/components/preview-announcement/preview-announcement.component';
//import { UserAnnouncementComponent } from './announcement/components/user-announcement/user-announcement.component';
//import { UserPreviewAnnouncementComponent } from './announcement/components/user-preview-announcement/user-preview-announcement.component';
import { LoginComponent } from './auth/Login/login.component';
import { TermsAndConditionsDialogComponent } from './auth/terms-and-conditions/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { TermsAndConditionsComponent } from './auth/terms-and-conditions/terms-and-conditions.component';
import { UserManualComponent } from './auth/user-manual/user-manual.component';
import { BusinessReportComponent } from './business-report/business-report.component';
import { ClientComponent } from './client/client.component';
import { ClientInfoComponent } from './client/components/client-info/client-info.component';
import { ClientFileInfoComponent } from './client/components/client-fileinfo/clientfileinfo.component';
import { ClientfileschedulesComponent } from './client/components/clientfileschedules/clientfileschedules.component';
import { ClientFileScheduleComponent } from './client/components/client-fileschedule/clientfileschedule.component';

import { ClientFileEffect } from './client/components/state/clientfile.effects';

import { FileScheduleReducer } from "./client/components/state/fileschedule_state/fileschedule.reducer";
import { FileScheduleEffect } from "./client/components/state/fileschedule_state/fileschedule.effects";
import { ClientsReducer } from "./client/components/state/client.reducer";
import { ClientsEffect } from './client/components/state/client.effects';


//import { ClientInfoEditComponent } from './client/components/client-info/components/clientinfoedit.component';
import { ClientStepperComponent } from './client/components/client-stepper/client-stepper.component';
import { DownloadInputFilesComponent } from './download-input-files/download-input-files.component';
import { DownloadReportComponent } from './download-report/download-report.component';
import { FeaturesRoutingModule } from './features-routing.module';
import { FEATURE_NAME, reducers } from './features.state';
import { GoToLoginComponent } from './go-to-login/go-to-login.component';
import { HangfireDashboardComponent } from './hangfire/components/hangfire-dashboard/hangfire-dashboard.component';
import { JobManagerComponent } from './hangfire/components/job-manager/job-manager.component';
import { IpFilteringEditComponent } from './ip-filtering/component/ip-filtering-edit/ip-filtering-edit.component';
import { IpFilteringComponent } from './ip-filtering/ip-filtering.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LookupPageComponent } from './lookup-page/lookup-page.component';
import { ForgetPasswordComponent } from './password-security/forget-password/forget-password.component';
import { PasswordRecoveryQuestionComponent } from './password-security/password-recovery-question/password-recovery-question.component';
import { PasswordSecurityComponent } from './password-security/password-security.component';
import { ResetPasswordSecurityComponent } from './password-security/reset-password-security/reset-password-security.component';
import { ReportDashboardComponent } from './report-dashboard/report-dashboard.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { RoleComponent } from './role-management/role/role.component';
import { SftpEditComponent } from './sftp/sftp-edit/sftp-edit.component';
import { SftpComponent } from './sftp/sftp.component';
import { SftpInfoEffect } from './sftp/state/sftp-info.effects';
import { SftpInfoReducer } from './sftp/state/sftp-info.reducer';
import { HolidayDateAddEditComponent } from './system-setup/components/holiday-date/holiday-date-add-edit/holiday-date-add-edit.component';
import { HolidayDateComponent } from './system-setup/components/holiday-date/holiday-date.component';
import { HolidayEditComponent } from './system-setup/components/holiday/holiday-edit/holiday-edit.component';
import { HolidayComponent } from './system-setup/components/holiday/holiday.component';
import { PasswordExpireDialogComponent } from './user/components/password-expire-dialog/password-expire-dialog';
import { ResetPasswordComponent } from './user/components/reset-password/reset-password.component';
import { UserEditComponent } from './user/components/user-edit/user-edit.component';
import { UserPasswordChangeComponent } from './user/components/user-password-change/user-password-change.component';
import { UserProfileComponent } from './user/components/user-profile/user-profile.component';
import { UserComponent } from './user/user.component';

import { WorkQueueComponent } from './work-queue/work-queue.component';
import { LenderRemediationQueueComponent } from './work-queue/components/lender-remediation/lender-remediation.component';
import { LenderReconciliationQueueComponent } from './work-queue/components/lenderreconciliation-queue/lenderreconciliation-queue.component';
import { UsQueueComponent } from './work-queue/components/us-queue/us-queue.component';
import { LenderRemediationQueueEffect } from './work-queue/state/lender-remediation/lender-remediation.effects';
import { LenderRemediationQueueReducer } from './work-queue/state/lender-remediation/lender-remediation.reducer';
import { LenderReconciliationQueueEffect } from './work-queue/state/lenderreconciliation-queue/lenderreconciliation-queue.effects';
import { LenderReconciliationQueueReducer } from './work-queue/state/lenderreconciliation-queue/lenderreconciliation-queue.reducer';
import { UsQueueEffect } from './work-queue/state/us-queue/us-queue.effects';
import { UsQueueReducer } from './work-queue/state/us-queue/us-queue.reducer';
import { ClientFileInfoParentComponent } from './client/components/client-file-info-parent/client-file-info-parent.component';
import { ClientFileInfoEditComponent } from './client/components/client-file-info-parent/components/client-file-info-edit/client-file-info-edit.component';


const COMPONENTS = [
  AccountViewComponent,
  AdminReportComponent,
  //AnnouncementComponent,
  BusinessReportComponent,
  ClientComponent,
  ClientComponent,
  ClientInfoComponent,
  ClientFileInfoComponent,
  ClientfileschedulesComponent,
  ClientFileScheduleComponent,
  //ClientInfoEditComponent,
  ClientStepperComponent,
  DownloadInputFilesComponent,
  DownloadReportComponent,
  ForgetPasswordComponent,
  GoToLoginComponent,
  HangfireDashboardComponent,
  HolidayComponent,
  HolidayDateComponent,
  IpFilteringComponent,
  JobManagerComponent,
  LandingPageComponent,
  LoginComponent,
  LookupPageComponent,
  PasswordExpireDialogComponent,
  PasswordRecoveryQuestionComponent,
  PasswordSecurityComponent,
  ReportDashboardComponent,
  ResetPasswordSecurityComponent,
  RoleComponent,
  RoleManagementComponent,
  SftpComponent,
  TermsAndConditionsComponent,
  TermsAndConditionsDialogComponent,
  UserComponent,
  UserManualComponent,
  UserPasswordChangeComponent,
  UserProfileComponent,
  LenderRemediationQueueComponent,
  LenderReconciliationQueueComponent,
  UsQueueComponent,
  WorkQueueComponent,
  QueueHistoryDialogComponent

];
const SERVICES = [AuthGuardService, AuthService, SftpInfoService, UserService];

const COMPONENTS_DYNAMIC = [
  HolidayDateAddEditComponent,
  HolidayEditComponent,
  IpFilteringEditComponent,
  //PreviewAnnouncementComponent,
  ResetPasswordComponent,
  SftpEditComponent,
  UserEditComponent,
  UserPasswordChangeComponent,
];

@NgModule({
  imports: [
    GridModule,
    ExcelModule,
    SharedModule,
    NgxPrintModule,
    FeaturesRoutingModule,
    NgxMaterialTimepickerModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    NgxDatatableModule,
    BrowserAnimationsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    PdfViewerModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      preventDuplicates: true,
      closeButton: true,
      positionClass: 'toast-top-right',
    }),

    StoreModule.forFeature("clients", ClientsReducer),
    StoreModule.forFeature('lenderRemediationQueue', LenderRemediationQueueReducer),
    StoreModule.forFeature(FEATURE_NAME, reducers),
    StoreModule.forFeature('lenderReconciliationQueue', LenderReconciliationQueueReducer),
    StoreModule.forFeature('sftp', SftpInfoReducer),
    StoreModule.forFeature('usQueue', UsQueueReducer),
    //StoreModule.forFeature('vehiclePostQueue', VehiclePostQueueReducer),
    //StoreModule.forFeature('lvsTrigger', LvsTriggerReducer),
    StoreModule.forFeature("fileschedule", FileScheduleReducer),
    EffectsModule.forFeature([
      LenderRemediationQueueEffect,
      LenderReconciliationQueueEffect,
      ClientsEffect,
      ClientFileEffect,
      FileScheduleEffect,
      SftpInfoEffect,
      UsQueueEffect,
      //VehiclePostQueueEffect,
      //LvsQueueEffect
    ]),
  ],
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ClientFileInfoParentComponent, ClientFileInfoEditComponent],
  providers: [SERVICES],
  
})
export class FeaturesModule { }
